import { z } from 'zod';
export const videoProviderSchema = z.enum(['rutube', 'vk_video']);
export const videoKindSchema = z.enum(['reel', 'video']);
export const videoScopeSchema = z.enum(['for_you', 'latest', 'subscriptions', 'saved', 'history']);
export const videoTopicSchema = z.enum([
    'humor',
    'education',
    'science',
    'technology',
    'games',
    'music',
    'sport',
    'travel',
    'food',
    'auto',
    'culture',
    'business'
]);
export const VIDEO_TOPICS = videoTopicSchema.options;
export const videoFeedQuerySchema = z
    .object({
    scope: videoScopeSchema.default('for_you'),
    topic: videoTopicSchema.optional(),
    q: z.string().trim().max(120).optional(),
    cursor: z.string().trim().min(1).max(1_000).optional(),
    limit: z.coerce.number().int().min(1).max(50).default(24),
    featured: z
        .enum(['true', 'false'])
        .transform((value) => value === 'true')
        .optional()
})
    .strict();
export const videoProgressSchema = z
    .object({
    positionSeconds: z
        .number()
        .finite()
        .min(0)
        .max(24 * 60 * 60),
    durationSeconds: z
        .number()
        .finite()
        .positive()
        .max(24 * 60 * 60)
        .optional()
})
    .strict();
export const videoCommentCreateSchema = z
    .object({ text: z.string().trim().min(1).max(2_000) })
    .strict();
export const videoReportSchema = z
    .object({
    reason: z.string().trim().min(2).max(120),
    comment: z.string().trim().max(1_000).optional()
})
    .strict();
export const videoPreferencesSchema = z
    .object({
    topics: z.array(videoTopicSchema).max(VIDEO_TOPICS.length),
    setupCompleted: z.boolean()
})
    .strict()
    .refine((value) => !value.setupCompleted || value.topics.length === 0 || value.topics.length >= 3, 'Выберите хотя бы три темы или пропустите настройку');
export const videoSubscriptionSchema = z
    .object({ notifyNewVideos: z.boolean().default(false) })
    .strict();
export const adminVideoSourceCreateSchema = z
    .object({ channelUrl: z.string().trim().url().max(500) })
    .strict();
export const adminVideoSettingsSchema = z
    .object({ vkServiceToken: z.string().trim().min(20).max(2_000).optional() })
    .strict();
export const adminVideoSourceUpdateSchema = z
    .object({
    enabled: z.boolean().optional(),
    title: z.string().trim().min(1).max(160).optional(),
    topic: videoTopicSchema.nullable().optional()
})
    .strict()
    .refine((value) => Object.keys(value).length > 0, 'Нужно изменить хотя бы одно поле');
export const adminVideoItemUpdateSchema = z
    .object({
    kind: videoKindSchema.nullable().optional(),
    visible: z.boolean().optional(),
    featured: z.boolean().optional()
})
    .strict()
    .refine((value) => Object.keys(value).length > 0, 'Нужно изменить хотя бы одно поле');
export const videoIdParamsSchema = z.object({ videoId: z.string().cuid() }).strict();
export const videoSourceIdParamsSchema = z.object({ sourceId: z.string().cuid() }).strict();
export const videoCommentIdParamsSchema = z.object({ commentId: z.string().cuid() }).strict();
//# sourceMappingURL=videos.js.map